import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const passageService = {
    getAll,
    getAllPassages,
    addPassage,
    updatePassage,
    deletePassage,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/question/passages/getAllPassages/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllPassages() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passages/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addPassage(newPassage) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newPassage),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passages/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updatePassage(passageItem, passageId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(passageItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passages/update/${passageId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deletePassage(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/question/passages/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
